module.exports = __webpack_public_path__ + "static/media/20.fe6b8a38.png";